import classNames from 'classnames';

import BasicButton from './BasicButton';

import styles from '../../styles/buttons/via-button.module.css';

const DEFAULT_VIA: string[] = [];

export interface ViaButtonProps {
    via?: string[];
    value?: string | null;
    loading?: boolean;
    className?: string | null;
    onChange?: ((value: string) => void) | null;
}

function ViaButton({
    via = DEFAULT_VIA,
    value = null,
    className = null,
    onChange = null,
}: ViaButtonProps) {
    const onClick = (newValue: string) => {
        if (onChange !== null) {
            onChange(newValue);
        }
    };

    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.control}>
                <div className={styles.methods}>
                    {via.map((method, index) => (
                        <BasicButton
                            key={method}
                            className={classNames([
                                styles.method,
                                {
                                    [styles.active]: value === method,
                                },
                            ])}
                            onClick={() => onClick(method)}
                        >
                            {method}
                        </BasicButton>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ViaButton;
